import { render, staticRenderFns } from "./ScreenServiceStudent.vue?vue&type=template&id=049a84ef&scoped=true&"
import script from "./ScreenServiceStudent.vue?vue&type=script&lang=js&"
export * from "./ScreenServiceStudent.vue?vue&type=script&lang=js&"
import style0 from "./ScreenServiceStudent.vue?vue&type=style&index=0&id=049a84ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a84ef",
  null
  
)

export default component.exports